export default "__VITE_ASSET__Bzz20dV$__"